import { REFERRAL_KEY, WINDFALL_REFERRAL_VALUE } from './constants';

export function tradeWindfallReferralRule() {
    const query = new URLSearchParams(window.location.search);
    const referralSource = query.get(REFERRAL_KEY);
    if (referralSource === WINDFALL_REFERRAL_VALUE) {
        return Promise.resolve(true);
    }

    return Promise.resolve(false);
}
